<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { Toast } from "@/state/helpers";
import {mapState} from "vuex";
import axios from 'axios';
import { timeSince } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Clients",
  },
  components: {PageHeader, Layout},
  props: {
  },
  data() {
    return {
      title: 'Influencer Payouts',
      currentPage: 1,
      pageSize: 15,
      statusFilter: 'All'
    }
  },
  computed: {
    ...mapState('admin', {
      payouts: (state) => state.payouts
    }),
    filteredPayouts () {
      return this.statusFilter === 'All' ? this.payouts : this.payouts.filter(item => this.getStatus(item) === this.statusFilter);
    },
    currentPagePayouts () {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredPayouts.slice(start, end);
    }
  },
  created () {
    this.currentPage = this.$route.query.page || 1;
  },
  methods: {
    getStatus (payout) {
      if (payout.archived_at) {
        return 'Archived'
      } else if (payout.paid_at) {
        return 'Paid'
      } else {
        return 'Pending'
      }
    },
    async pay (payout) {
      const result = await Swal.fire({
        title: `Are you sure you want to payout ${payout.influencer_profile.username}?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#868585",
        confirmButtonText: "Pay"
      })
      if(result.value) {
        try {
          this.$store.commit('loader/START_LOADING');
          await axios.post(`/admin/influencer/payouts/${payout.id}/pay`, {});
          await this.$store.dispatch('admin/getPayoutsData');
          Toast.fire({
            title: `User ${payout.influencer_profile.username} is paid requested amount successfully.`,
            icon: "success",
          })
        } catch (e) {
          Toast.fire({
            title: `Something went wrong when trying to pay user. Please try again.`,
            icon: "error",
          })
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    timeAgo(time) {
      return `${timeSince(new Date(time))} ago`;
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col text-right mb-2">
        <b-dropdown dropleft variant="info" size="sm">
          <template slot="button-content">
            <i class="mdi mdi-chevron-left"></i>
            Status: {{ statusFilter }}
          </template>
          <b-dropdown-item-button @click="statusFilter = 'Pending'">Pending</b-dropdown-item-button>
          <b-dropdown-item-button @click="statusFilter = 'Paid'">Paid</b-dropdown-item-button>
          <b-dropdown-item-button @click="statusFilter = 'All'">All</b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="table-responsive mb-0">
          <table class="table table-centered table-nowrap text-center">
            <thead class="thead-light">
            <tr>
              <th class="text-left">{{ $t('Requested at') }}</th>
              <th class="text-left">{{ $t('Influencer') }}</th>
              <th class="text-left">{{ $t('Status') }}</th>
              <th class="text-left">{{ $t('Requested amount') }}</th>
              <th class="text-left">{{ $t('Payout fee') }}</th>
              <th class="text-left">{{ $t('To be paid') }}</th>
              <th class="text-left"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="payout in currentPagePayouts" :key="payout.id">
              <td class="text-left">{{ timeAgo(payout.created_at) }}</td>
              <td class="text-left"><RouterLink :to="`/admin/influencers/${payout.influencer_id}`">{{ payout.influencer_profile.username }}</RouterLink></td>
              <td class="text-left">
                <b-badge v-if="getStatus(payout) === 'Pending'" class="badge-soft-warning font-size-11">Pending</b-badge>
                <b-badge v-if="getStatus(payout) === 'Paid'" class="badge-soft-success font-size-11">Paid</b-badge>
                <b-badge v-if="getStatus(payout) === 'Archived'" class="badge-soft-danger font-size-11">Archived</b-badge>
              </td>
              <td class="text-left">{{ payout.requested_amount_eur }} &euro;</td>
              <td class="text-left">{{ payout.payout_fee_eur }} &euro;</td>
              <td class="text-left font-weight-bold">{{ payout.to_be_paid_eur }} &euro;</td>
              <td class="text-left">
                <div class="d-flex justify-content-end">
                  <button :disabled="getStatus(payout) !== 'Pending'" @click="pay(payout)" class="btn btn-sm btn-block btn-success something">
                  {{ getStatus(payout) !== 'Pending' ? 'Paid' : 'Pay' }}
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <b-pagination
                  v-model="currentPage"
                  :total-rows="filteredPayouts.length"
                  :per-page="pageSize"
                  aria-controls="my-table"
                  class="justify-content-center mt-3"
          ></b-pagination>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>

</style>
